const primaryCards = [
  {
    icon: 'ri-seedling-line',
    title: 'Early Intervention',
    category: 'Developmental',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    tagColor: 'text-emerald-500',
    accentBar: 'bg-emerald-400',
    description:
      'Early therapy services — occupational, physical, and speech — can dramatically improve developmental outcomes for children with CSCF. Most children qualify for services from birth through age 3 under federal programs.',
    tips: [
      'Request an evaluation through your local school district or early intervention program',
      'Occupational therapy helps with feeding, fine motor, and sensory challenges',
      'Speech therapy is especially important given the high rate of hearing loss in CSCF',
    ],
    link: 'https://www.cdc.gov/ncbddd/actearly/',
    linkLabel: 'CDC Early Intervention Guide',
  },
  {
    icon: 'ri-volume-mute-line',
    title: 'Hearing Specialists',
    category: 'Audiology',
    bg: 'bg-accent-50',
    border: 'border-accent-100',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    tagColor: 'text-accent-500',
    accentBar: 'bg-accent-400',
    description:
      'Bilateral conductive hearing loss is present in most individuals with CSCF. Finding an experienced pediatric audiologist and ENT specialist early is critical for language development and quality of life.',
    tips: [
      'Request a full audiological evaluation including ABR (auditory brainstem response) testing',
      'Discuss hearing aid options and cochlear implant candidacy with your audiologist',
      'Recurrent ear infections may require tympanostomy tube placement',
    ],
    link: 'https://www.asha.org/public/hearing/',
    linkLabel: 'Hearing Resources (ASHA)',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Pediatric Cardiology',
    category: 'Cardiology',
    bg: 'bg-red-50',
    border: 'border-red-100',
    iconBg: 'bg-red-100',
    iconColor: 'text-red-500',
    tagColor: 'text-red-400',
    accentBar: 'bg-red-400',
    description:
      'Cardiac involvement is a hallmark of CSCF. Valvular defects, septal abnormalities, and in some cases dilated cardiomyopathy require ongoing monitoring by a pediatric cardiologist experienced with complex congenital heart disease.',
    tips: [
      'Seek a pediatric cardiologist at a children\'s hospital with a complex congenital heart program',
      'Ensure your cardiologist is aware of the CSCF diagnosis and MAP3K7 gene involvement',
      'Regular echocardiograms are essential — frequency depends on severity of cardiac findings',
    ],
    link: 'https://www.chop.edu/conditions-diseases/congenital-heart-disease',
    linkLabel: 'CHOP Congenital Heart Disease',
  },
  {
    icon: 'ri-school-line',
    title: 'School Support',
    category: 'Education',
    bg: 'bg-amber-50',
    border: 'border-amber-100',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    tagColor: 'text-amber-500',
    accentBar: 'bg-amber-400',
    description:
      'Children with CSCF may qualify for Individualized Education Programs (IEPs), 504 plans, and specialized services. Understanding your child\'s educational rights is one of the most powerful tools for advocacy.',
    tips: [
      'Request a full educational evaluation from your school district — it is free and legally required',
      'An IEP provides legally binding accommodations and services tailored to your child\'s needs',
      'A 504 plan covers accommodations without specialized instruction (e.g., preferential seating, extended time)',
    ],
    link: 'https://www.understood.org/articles/the-difference-between-ieps-and-504-plans',
    linkLabel: 'IEP vs 504 Guide (Understood.org)',
  },
  {
    icon: 'ri-body-scan-line',
    title: 'Orthopedics & Spine',
    category: 'Skeletal',
    bg: 'bg-brand-50',
    border: 'border-brand-100',
    iconBg: 'bg-brand-100',
    iconColor: 'text-brand-600',
    tagColor: 'text-brand-500',
    accentBar: 'bg-brand-400',
    description:
      'Vertebral fusions, scoliosis, and joint abnormalities are common in CSCF. A pediatric orthopedic specialist can monitor spinal development and recommend bracing, physical therapy, or surgical intervention when needed.',
    tips: [
      'Annual spine X-rays help track progression of vertebral fusions and scoliosis',
      'Physical therapy can improve mobility, strength, and posture',
      'Cervical spine instability should be evaluated before any surgical procedure requiring anesthesia',
    ],
    link: 'https://www.posna.org/Patients-Families/Find-a-Pediatric-Orthopaedic-Surgeon',
    linkLabel: 'Find a Pediatric Orthopedist (POSNA)',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Feeding & Nutrition',
    category: 'GI & Nutrition',
    bg: 'bg-orange-50',
    border: 'border-orange-100',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-600',
    tagColor: 'text-orange-500',
    accentBar: 'bg-orange-400',
    description:
      'Feeding difficulties are very common in CSCF, particularly in infancy. A feeding therapy team — including a speech-language pathologist and dietitian — can help address oral motor challenges, reflux, and nutritional needs.',
    tips: [
      'A feeding evaluation by a speech-language pathologist can identify oral motor or swallowing issues',
      'Gastroesophageal reflux is common — discuss medication and positioning strategies with your GI team',
      'Some children require G-tube (gastrostomy tube) feeding; connect with families who have navigated this',
    ],
    link: 'https://www.naspghan.org/page/find-a-gi-doctor',
    linkLabel: 'Find a Pediatric GI Specialist',
  },
];

const additionalResources = [
  { icon: 'ri-microscope-line', label: 'Genetic Counseling', text: 'A genetic counselor can help families understand the MAP3K7 variant, recurrence risk, and implications for other family members.' },
  { icon: 'ri-mental-health-line', label: 'Mental Health Support', text: 'Caring for a child with a rare disease is emotionally demanding. Therapists experienced with rare disease families can provide vital support.' },
  { icon: 'ri-global-line', label: 'NORD (Rare Disease Network)', text: 'The National Organization for Rare Disorders connects families with rare disease communities, research, and advocacy resources.' },
  { icon: 'ri-group-line', label: 'Parent-to-Parent Support', text: 'Connecting with another parent who has navigated CSCF can be more valuable than any pamphlet. Join our community to find peer support.' },
];

export default function ResourcesGrid() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">

        {/* Primary 3x2 resource grid */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 font-heading mb-2">Key Support Areas</h2>
          <p className="text-gray-500 text-sm font-body mb-10">
            The six areas below are where families most often need guidance when navigating a CSCF diagnosis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {primaryCards.map((card) => (
            <div
              key={card.title}
              className={`rounded-2xl border ${card.bg} ${card.border} flex flex-col overflow-hidden`}
            >
              {/* Accent top bar */}
              <div className={`h-1 w-full ${card.accentBar}`} />

              <div className="p-6 flex flex-col flex-grow">
                {/* Category tag */}
                <span className={`text-xs font-semibold uppercase tracking-widest font-heading mb-4 ${card.tagColor}`}>
                  {card.category}
                </span>

                {/* Icon + Title */}
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-11 h-11 flex items-center justify-center ${card.iconBg} rounded-xl flex-shrink-0`}>
                    <i className={`${card.icon} text-xl ${card.iconColor}`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 font-heading">{card.title}</h3>
                </div>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed font-body mb-5">{card.description}</p>

                {/* Tips */}
                <ul className="space-y-2 mb-6 flex-grow">
                  {card.tips.map((tip, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-500 font-body">
                      <i className="ri-checkbox-circle-line text-gray-400 mt-0.5 flex-shrink-0"></i>
                      <span>{tip}</span>
                    </li>
                  ))}
                </ul>

                {/* Learn more link */}
                <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={`inline-flex items-center gap-1.5 text-sm font-semibold font-body transition-colors cursor-pointer ${card.iconColor} hover:opacity-75`}
                >
                  <i className="ri-external-link-line text-xs"></i>
                  {card.linkLabel}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Additional resources strip */}
        <div className="bg-gray-50 border border-gray-100 rounded-2xl p-8 mb-20">
          <h3 className="text-base font-bold text-gray-900 font-heading mb-6 flex items-center gap-2">
            <i className="ri-add-circle-line text-brand-500"></i>
            Additional Support Resources
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {additionalResources.map((item) => (
              <div key={item.label} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-gray-500 text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-800 font-heading mb-1">{item.label}</p>
                  <p className="text-xs text-gray-500 font-body leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom notice */}
        <div className="text-center">
          <div className="inline-block max-w-2xl">
            {/* Icon */}
            <div className="w-14 h-14 flex items-center justify-center bg-brand-50 rounded-full mx-auto mb-5">
              <i className="ri-time-line text-brand-500 text-2xl"></i>
            </div>

            {/* Notice text */}
            <div className="bg-brand-50 border border-brand-100 rounded-2xl px-8 py-7 mb-8">
              <p className="text-brand-700 font-semibold text-lg font-heading mb-2">
                More resources will be added as our community grows.
              </p>
              <p className="text-brand-600/70 text-sm font-body leading-relaxed">
                CSCF Support is a growing community. As more families connect and share their experiences, we will continue to expand this resource library with vetted, practical guidance.
              </p>
            </div>

            {/* CTA */}
            <p className="text-gray-400 text-sm font-body mb-5">
              Know of a resource that should be listed here?
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-brand-500 text-white font-semibold rounded-full hover:bg-brand-600 transition-colors whitespace-nowrap cursor-pointer font-body"
              >
                <i className="ri-group-line"></i>
                Connect with the Community
              </a>
              <a
                href="/community#story-form"
                className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-gray-200 text-gray-700 font-semibold rounded-full hover:border-brand-300 hover:text-brand-600 transition-colors whitespace-nowrap cursor-pointer font-body"
              >
                <i className="ri-quill-pen-line"></i>
                Share a Resource
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
